/* Scope storefront search to title / SKU / barcode (UPC) / tag / vendor.
   Shopify's default search matches every field (including the description body) and applies
   typo tolerance, so a query like "fl5" also returned X5 / M5 / K5 parts and "does not fit FL5"
   items. Field-scoped queries disable both. Each word becomes
     (title:w OR variants.sku:w OR variants.barcode:w OR tag:w OR vendor:w [OR id:w if w is all digits])
   and words are AND-ed. The results page un-wraps this for display via snippets/search-terms-raw.liquid.

   The visible input is NEVER modified (an earlier version rewrote it in place, which flashed the
   scoped syntax in the box until the results page loaded). Instead the submit is intercepted and
   the browser is sent to the scoped URL. If JS is unavailable the raw query submits as before. */
(function () {
  function scope(q) {
    q = String(q || '').replace(/[():"]/g, ' ').trim();   // strip query-syntax characters
    if (!q) return q;
    if (/(^|\s)(title|tag|vendor|variants\.(sku|barcode)):/i.test(q)) return q;   // already field-scoped
    return q.split(/\s+/).map(function (w) {
      var clause = 'title:' + w + ' OR variants.sku:' + w + ' OR variants.barcode:' + w + ' OR tag:' + w + ' OR vendor:' + w;
      /* Shopify's undocumented id: filter matches the internal product id (the "Product ID" shown on
         the PDP). Only for all-digit words: id:<non-number> makes the whole query return 0. */
      if (/^\d+$/.test(w)) clause += ' OR id:' + w;
      return '(' + clause + ')';
    }).join(' ');
  }
  window.nvdScopeQuery = scope;   /* reused by the theme's predictive (dropdown) search in script.header.js */
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || form.getAttribute('role') !== 'search') return;
    var q = form.querySelector('input[name="q"]');
    if (!q || !q.value.trim()) return;
    /* a highlighted predictive suggestion is handled by the theme (it navigates to that item) */
    var ps = form.closest('predictive-search');
    if (ps && ps.querySelector('[aria-selected="true"] a')) return;
    ev.preventDefault();
    var params = new URLSearchParams(new FormData(form));
    params.set('q', scope(q.value));
    var action = form.getAttribute('action') || '/search';
    window.location.assign(action.split('?')[0] + '?' + params.toString());
  }, true);   /* capture phase: runs before the theme's own submit handlers */
})();
